import {renderDisclaimer} from "./messages";
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Hondt} from "./hondt";
import {getContrastYIQ} from "../colors";

export function updateGraphs(state) {
    if (validateSelection(state)) {
        state.regidors = regidors(getGraphInput(state))
        hideNoData()
        renderRegidorsChart(state)
        renderVotesChart(state)
        renderHistoricChart(state)
    } else {
        showNoData(state)
        renderHistoricChart(state)
    }
    renderDisclaimer(state)
}

function validateSelection(state) {
    const vots = state.vots[state.selected === 'total' ? 'Total' : state.selected]

    return vots.find(v => v > 0)
}

function getHistoricInput(state) {
    const partitsSet = new Set()

    const years = Object.keys(state.historicalData)

    for(const year of Object.values(state.historicalData)) {
        year.partits.filter(p => !['nuls', 'blanc'].includes(p.toLowerCase())).forEach(p => partitsSet.add(sanitizePartit(p)))
    }
    const partits = Array.from(partitsSet)

    const colorMap = new Map()
    for(const year of Object.values(state.historicalData)) {
        for (const partit of Object.keys(year.colors)) {
            if (!colorMap.has(sanitizePartit(partit))) {
                colorMap.set(sanitizePartit(partit), year.colors[partit])
            }
        }
    }

    const colors = Object.fromEntries(colorMap)

    const historicVots = {}
    const historicRegidors = {}
    const historicPercent = {}

    for(const partit of partits) {
        historicVots[partit] = []
        historicRegidors[partit] = []
        historicPercent[partit] = []
    }

    for (let yearIndex=0; yearIndex<years.length; yearIndex++) {
        const year = years[yearIndex]

        for(const partit of partits) {
            historicVots[partit][yearIndex] = 0
            historicPercent[partit][yearIndex] = 0
        }

        let vots = []
        switch (state.selected.toLowerCase()) {
            case 'total':
                vots = state.historicalData[year].zones['total'];
                break
            default:
                let selected = state.selected
                if (state.selected.split('-').length===3) {
                    selected = state.selected.split('-').slice(0,2).join('-')
                }
                vots = state.historicalData[year].vots[selected]
        }
        for(let i=0; i<state.historicalData[year].partits.length; i++) {
            const p = state.historicalData[year].partits[i]
            if (['nuls', 'blanc'].includes(p.toLowerCase())) {
                continue
            }
            const sanitized = sanitizePartit(p)

            historicVots[sanitized][yearIndex] = vots[i]
            historicPercent[sanitized][yearIndex] = state.historicalData[year].percent[i]
        }

        const regidorsYear = regidors({ partits, vots: [ ...partits.map(p => historicVots[p][yearIndex]), 0]})

        for(let partitIndex = 0;  partitIndex<partits.length; partitIndex++) {
            const p = partits[partitIndex]
            historicRegidors[p][yearIndex] = regidorsYear[partitIndex]
        }
    }

    return { partits, colors, years: Object.keys(state.historicalData), historicVots, historicRegidors, historicPercent }
}

function sanitizePartit(p) {
    switch (p.toLowerCase()) {
        case 'bloc':
        case 'compromís':
            return 'Bloc/Compromís';
        case 'cibe/bloc':
            return "CIBE";
        default:
            return p
    }
}

function getGraphInput(state) {
    const partits = state.partits.filter(p => !['nuls', 'blanc'].includes(p.toLowerCase()))
    let vots
    switch (state.selected.toLowerCase()) {
        case 'total':
            vots = state.zones['total'];
            break
        default:
            vots = state.vots[state.selected]
    }

    return { partits, vots }
}

function regidors({ partits, vots }) {
    if (vots.filter(v => v > 0).length === 0) {
        return partits.map(p => 0)
    }

    const limit = 0.05;
    const regidors = 17;

    const hndt = new Hondt(partits,limit,regidors);

    let i
    for (i=0; i<partits.length; i++) {
        hndt.setVots(partits[i],vots[i]);
    }

    hndt.blancs = vots[i];

    hndt.calculEscons();

    return partits.map(p => hndt.getEscons(p))
}

function showNoData(state) {
    const e = document.getElementById('eleccions-regidors-graph')
    if (!e.classList.contains('is-hidden')) {
        e.classList.add('is-hidden')
    }

    const d = document.getElementById('disclaimer-regidors')
    if (!d.classList.contains('is-hidden')) {
        d.classList.add('is-hidden')
    }

    const v = document.getElementById('eleccions-vots-graph')
    if (!v.classList.contains('is-hidden')) {
        v.classList.add('is-hidden')
    }

    const m = document.getElementById('eleccions-regidors-nodata')
    m.innerHTML = `No hi ha dades disponibles per a la selecció actual: ${getSelectedMessage(state.selected)}`
    if (m.classList.contains('is-hidden')) {
        m.classList.remove('is-hidden')
    }

    const historicTab = document.getElementById('historic-tab')
    const ecol = document.getElementById('eleccions-regidors-graph-column')
    const hcol = document.getElementById('eleccions-historic-graph-column')
    if (historicTab.classList.contains('is-active')) {
        const ecol = document.getElementById('eleccions-regidors-graph-column')
        const vcol = document.getElementById('eleccions-vots-graph-column')


        hcol.classList.remove('is-hidden')
        !ecol.classList.contains('is-hidden') && ecol.classList.add('is-hidden')
        !d.classList.contains('is-hidden') && d.classList.add('is-hidden')
        !vcol.classList.contains('is-hidden') && vcol.classList.add('is-hidden')

        if (!m.classList.contains('is-hidden')) {
            m.classList.add('is-hidden')
        }
    } else {
        ecol.classList.remove('is-hidden')
        !hcol.classList.contains('is-hidden') && hcol.classList.add('is-hidden')
    }
}

function hideNoData() {

    const regTab = document.getElementById('regidors-tab')
    const votTab = document.getElementById('vots-tab')
    const historicTab = document.getElementById('historic-tab')

    const e = document.getElementById('eleccions-regidors-graph-column')
    const d = document.getElementById('disclaimer-regidors')
    const v = document.getElementById('eleccions-vots-graph-column')
    const h = document.getElementById('eleccions-historic-graph-column')

    if (regTab.classList.contains('is-active')) {
        e.classList.remove('is-hidden')
        d.classList.remove('is-hidden')
        !v.classList.contains('is-hidden') && v.classList.add('is-hidden')
        !h.classList.contains('is-hidden') && h.classList.add('is-hidden')
    }

    if (votTab.classList.contains('is-active')) {
        v.classList.remove('is-hidden')
        !e.classList.contains('is-hidden') && e.classList.add('is-hidden')
        !d.classList.contains('is-hidden') && d.classList.add('is-hidden')
        !h.classList.contains('is-hidden') && h.classList.add('is-hidden')
    }

    if (historicTab.classList.contains('is-active')) {
        h.classList.remove('is-hidden')
        !e.classList.contains('is-hidden') && e.classList.add('is-hidden')
        !d.classList.contains('is-hidden') && d.classList.add('is-hidden')
        !v.classList.contains('is-hidden') && v.classList.add('is-hidden')
    }

    const m = document.getElementById('eleccions-regidors-nodata')
    if (!m.classList.contains('is-hidden')) {
        m.classList.add('is-hidden')
    }
}

function renderVotesChart(state) {
    if (state.votsChart) {
        state.votsChart.destroy()
    }

    const element = document.getElementById('eleccions-vots-graph')

    const labels = state.partits

    const { vots } = getGraphInput(state)

    state.votsChart = new Chart( element, {
        type: 'bar',
        data: {
            labels,
            datasets: [{
                data: vots,
                backgroundColor: Object.values(state.colors)
            }]
        },
        options: {
            layout: {
                padding: 20,
            },
            scales: {
                y: {
                    beginAtZero: true
                }
            },
            plugins: {
                tooltip: {
                    enabled: true
                },
                legend: {
                    display: false
                },
            }
        }
    })
}


function renderHistoricChart(state) {
    if (state.historicVotsChart) {
        state.historicVotsChart.destroy()
    }

    if (state.historicRegidorsChart) {
        state.historicRegidorsChart.destroy()
    }

    const elemRegidors = document.getElementById('eleccions-historic-regidors-graph')
    const elemVots = document.getElementById('eleccions-historic-vots-graph')

    const { partits, colors, historicVots, historicRegidors, historicPercent, years } = getHistoricInput(state)

    const labels = years

    const regidorsDataset = partits.map(p => {
        return {
            label: p,
            backgroundColor: colors[p],
            data: historicRegidors[p]
        }
    })

    const votsDataset = partits.map(p => {
        return {
            label: p,
            borderColor: colors[p],
            backgroundColor: colors[p],
            data: historicVots[p],
            fill: true
        }
    })

    state.historicRegidorsChart = new Chart( elemRegidors, {
        type: 'bar',
        data: {
            labels,
            datasets: regidorsDataset
        },
        options: {
            layout: {
                padding: 20,
            },
            scales: {
                y: {
                    beginAtZero: true,
                    stacked: true
                },
                x: {
                    stacked: true
                }
            },
            plugins: {
                tooltip: {
                    enabled: true
                },
                legend: {
                    display: false,
                    position: 'bottom',
                },
            }
        }
    })

    state.historicVotsChart = new Chart( elemVots, {
        type: 'line',
        data: {
            labels,
            datasets: votsDataset
        },
        options: {
            layout: {
                padding: 20,
            },
            interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: 'Any'
                    }
                },
                y: {
                    beginAtZero: true,
                    stacked: true,
                    title: {
                        display: true,
                        text: 'Vots'
                    }
                }
            },
            plugins: {
                tooltip: {
                    enabled: true,
                    mode: 'index',
                    callbacks: {
                        label: function(context) {
                            if (state.selected.toLowerCase() === 'total') {
                                const yearIndex = context.dataIndex
                                const p = historicPercent[context.dataset.label][yearIndex]
                                return  `${context.formattedValue} (${ p === 0 ? 0 : (p/10).toFixed(1)}%)`
                            } else {
                                return context.formattedValue
                            }
                        }
                    }
                },
                legend: {
                    display: true,
                    position: 'bottom',
                },
            }
        }
    })
}

function renderRegidorsDisclaimer(selected) {

    const startMessage = "<strong>ATENCIÓ</strong><br/>S'està mostrant una simulació de quina seria la composició de l'Ajuntament si només es tingueren en compte els vots de<br/>"

    const e = document.getElementById('disclaimer-regidors')

    if(selected === 'total') {
        if (!e.classList.contains('is-hidden')) {
            e.classList.add('is-hidden')
        }
        e.innerHTML=''
    } else {
        e.classList.remove('is-hidden')

        const selectedMessage = getSelectedMessage(selected)
        e.innerHTML= `${startMessage} ${selectedMessage}`
    }
}

function getSelectedMessage(selected) {

    const parts = selected.split('-')

    if (!parts) {
        return ''
    }

    let message = '<kbd>'
    for(let i=0; i<parts.length;i++) {
        switch (i) {
            case 0:
                message = `${message}Districte ${parts[i]}`
                break;
            case 1:
                message = `${message} - Secció ${parts[i]}`
                break;
            case 2:
                message = `${message} - Mesa ${parts[i]}`
                break;
        }
    }

    return `${message}</kbd>`
}

function renderRegidorsChart(state) {

    if (state.regidorsChart) {
        state.regidorsChart.destroy()
    }

    renderRegidorsDisclaimer(state.selected)

    const element = document.getElementById('eleccions-regidors-graph')

    const labels = getLabels(state)

    state.regidorsChart = new Chart( element, {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        data: {
            labels,
            datasets: [{
                data: state.regidors,
                backgroundColor: Object.values(state.colors)
            }]
        },
        options: {
            rotation: 270,
            circumference: 180,
            layout: {
                padding: 20,
            },
            plugins: {
                tooltip: {
                  enabled: false
                },
                legend: {
                    display: false
                },
                datalabels: {
                    backgroundColor: function(context) {
                        return context.dataset.backgroundColor;
                    },
                    borderColor: 'white',
                        borderRadius: 25,
                        borderWidth: 2,
                        color: 'white',
                        display: function(context) {
                        var dataset = context.dataset;
                        var value = dataset.data[context.dataIndex];

                        return value >= 1;
                    },
                    font: {
                        weight: 'bold',
                        family: 'sans-serif',
                        size: 14
                    },
                    padding: 6,
                    anchor: 'center',
                    align: 'end',
                    clamp: true,
                    formatter: regidorsFormatter
                }
            }
        }
    })
}

function getSigla(partit) {
    switch (partit.toLowerCase()) {
        case 'reiniciem':
            return 'RB';
        case 'compromís':
            return ';)';
        case 'ciudadanos':
            return "C's"
        case 'podemos':
            return "Podem"
        default:
            return partit;
    }
}

function regidorsFormatter(value, context) {
    const sigla = getSigla(context.chart.data.labels[context.dataIndex])

    return `${sigla} ${value}`;
}

function getLabels(state) {
    return state.partits.filter(
            p => !['nuls', 'blanc'].includes(p.toLowerCase()))
}